import IApplicationConfig from '@/types/IApplicationConfig';
import dummyApplicationConfig from '@/utils/test/dummy_application_config';
import React from 'react';

export default React.createContext<IApplicationConfig>(dummyApplicationConfig);
